import { PenLine } from 'lucide-react'
import type { ReactElement } from 'react'
import { Button } from '~/shared/ui/button'

/** The quiet "or fill it in yourself" exit under a prompt start; pass the link as the child. */
export function ManualStart({ children }: { children: ReactElement }) {
  return (
    <Button asChild variant="secondary" className="self-center">
      {children}
    </Button>
  )
}

/** Pencil mark that leads the manual-start label. */
export function ManualStartIcon() {
  return <PenLine aria-hidden />
}
